import React from 'react';
import classNames from 'classnames';

import { CART_UPSELL_BANNER } from 'apps/cart/appConstants';

import { shopPods } from 'apps/cart/paths';
import { TranslatedMessage } from 'common/components/Intl';
import MembershipToggle from 'containers/MembershipToggle';
import MembershipInformation from 'apps/cart/components/sidebar/upsells/MembershipInformation';

export default class MembershipCartUpsell extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      accordionOpen: false,
    };
  }

  handleLearnMoreToggle = () => {
    this.setState(prevState => ({
      accordionOpen: !prevState.accordionOpen,
    }));

    analytics.track('Auto-Ship Learn More Selected', {
      name: 'cart upsell banner learn more',
      interaction: this.state.accordionOpen ? 'open' : 'closed',
    });
  };

  render() {
    const subscribableVariantOrdinalFreeFrequency =
      this.props.subscribableVariantFreeFrequency + 1;

    const toggleText = this.state.accordionOpen
      ? 'cart.upsell_banner.close'
      : 'cart.upsell_banner.learn_more';

    const bannerClassNames = classNames(
      'CartUpsellBanner',
      'CartUpsellBanner--membership',
      { 'CartUpsellBanner--has-open-accordion': this.state.accordionOpen }
    );

    return (
      <React.Fragment>
        <div className={bannerClassNames}>
          <div className="CartUpsellBanner__content">
            <h4 className="CartUpsellBanner__heading">
              <a className="CartUpsellBanner__heading__link" href={shopPods()}>
                <TranslatedMessage
                  id={'cart.upsell_banner.subscribe_and_save'}
                />
              </a>
            </h4>
            <p className="CartUpsellBanner__copy">
              <TranslatedMessage
                id={
                  'cart.upsell_banner.treatments.membership_cart_banner_new_text'
                }
                values={{ count: subscribableVariantOrdinalFreeFrequency }}
              />
            </p>
            <span
              className="CartUpsellBanner__link text--button"
              onClick={this.handleLearnMoreToggle}
              onKeyPress={this.handleLearnMoreToggle}
              role="button"
              tabIndex="0"
            >
              <TranslatedMessage id={toggleText} />
            </span>
          </div>
          <MembershipToggle eventLocation={CART_UPSELL_BANNER} />
        </div>

        {this.state.accordionOpen && (
          <MembershipInformation
            minimumSubscriptionItems={this.props.minimumSubscriptionItems}
            requiredInstallmentCount={this.props.requiredInstallmentCount}
            subscribableVariantFreeFrequency={
              this.props.subscribableVariantFreeFrequency
            }
          />
        )}
      </React.Fragment>
    );
  }
}
